import moment from "moment";
import {
  SALES_REPORT_EXPORT_NAMES,
  useSalesReportExportMutation,
} from "../../../../../../../../api/mutations/useSalesReportExportMutation";
import {
  API_DATE_FORMAT,
  FILE_EXPORT_TYPES,
} from "../../../../../../../../consts/api";
import { useAppTranslation } from "../../../../../../../../i18n/useAppTranslation";
import { uiNotification } from "../../../../../../../../services/UINotificationService";
import { composeDownloadDataUrl } from "../../../../../../../../utilities/api";

export function useDownloadExcel({ filter, clinic } = {}) {
  const { tCommon } = useAppTranslation.Common();

  const { mutateAsync, isLoading } = useSalesReportExportMutation({
    onError: () => {
      uiNotification.error(tCommon("error.exportXlsReports"));
    },
  });

  const initiate = async () => {
    let fromDate = null;
    let toDate = null;

    if (filter?.type === "days" && typeof filter.days === "number") {
      fromDate = moment().format(API_DATE_FORMAT);
      toDate = moment().add(filter.days, "days").format(API_DATE_FORMAT);
    } else if (filter?.type === "range" && filter?.from && filter?.to) {
      fromDate = moment(filter.from).format(API_DATE_FORMAT);
      toDate = moment(filter.to).format(API_DATE_FORMAT);
    }

    const res = await mutateAsync({
      rawPayload: {
        fromDate,
        toDate,
        clinic_id: clinic.value,
      },
      type: FILE_EXPORT_TYPES.xls,
      name: SALES_REPORT_EXPORT_NAMES.expiringLiabilityReport,
    });

    window.open(composeDownloadDataUrl(res.fileName), "_blank");
  };

  return {
    initiate,
    isLoading,
  };
}
